import { render, staticRenderFns } from "./LiableFieldList.vue?vue&type=template&id=01cbf06c&"
import script from "./LiableFieldList.vue?vue&type=script&lang=js&"
export * from "./LiableFieldList.vue?vue&type=script&lang=js&"
import style0 from "./LiableFieldList.vue?vue&type=style&index=0&id=01cbf06c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports